export default __webpack_public_path__ + "static/media/idea-start.b8b37e3c.png";